<template lang="pug">
div
    BaseHeader(
        :titulo='$t("configuracaoParametros.formulario.titulo.fornecedor")',
        :voltarPara='{ route: "ParametrosFornecedor" }'
    )
    .configuracao-parametros-detalhes
        h3.configuracao-parametros-detalhes__titulo {{ $t('configuracaoParametros.formulario.tituloVisualizar.fornecedor') }}
        .configuracao-parametros-detalhes__card
            div
                .resume(
                    v-for='(item, index) in dadosParametrosFornecedor',
                    :key='`fornecedor-detalhes-${index}`'
                )
                    .resume__item
                        .resume__label {{ item.label }}
                        .resume__value {{ item.value || '--' }}
        h3.configuracao-parametros-detalhes__titulo(
            v-if='dadosParametrosExcecoes.length'
        )
            | {{ $t('configuracaoParametros.formulario.tituloExecoes') }}
        .configuracao-parametros-detalhes__excecoes(
            v-for='(excecao, index) in dadosParametrosExcecoes',
            :key='`excecao-${index}`'
        )
            .configuracao-parametros-detalhes__card
                div
                    .resume(
                        v-for='(item, indexExcecao) in excecao',
                        :key='`excecao-${index}-item-${indexExcecao}`'
                    )
                        .resume__item(v-if='!item?.type || item?.opcional')
                            .resume__label {{ item.label }}
                            .resume__value {{ item.value || '--' }}
                div
                    el-checkbox(
                        :checked='obterValorNaotemExcecaoMunicipio(excecao)',
                        :value='obterValorNaotemExcecaoMunicipio(excecao)'
                    ) {{ $t('configuracaoParametros.formulario.checkboxNaoUtilizarExececaoMunicipio') }}
                div
                    .configuracao-parametros-detalhes__excecao-municipio(
                        v-for='(item, indexItem) in excecao.find(item => item.key === "municipios")?.value || []',
                        :key='`excecao-${index}-item-${indexItem}`'
                    )
                        .resume(
                            v-for='(municipio, indexMunicipio) in item',
                            :key='`excecao-${indexItem}-item-${indexMunicipio}`'
                        )
                            .resume__item
                                .resume__label {{ municipio.label }}
                                .resume__value {{ municipio.value || '--' }}
        .footer
            .footer__btn.voltar(@click='voltarConfiguracao')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import { buscarParametros } from '@/views/contratos-originacao/parametros/services/configuracaoFornecedorService';

export default {
    name: 'ParametrosFornecedorDetalhes',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume')
    },
    data() {
        return {
            configuracao: {},
            fornecedores: [],
            municipios: [],
            estados: []
        };
    },
    mounted() {
        this.buscarEstados();
        this.buscarFornecedores();
        this.buscarDados();
    },
    computed: {
        dadosParametrosFornecedor() {
            const resumeList = [
                {
                    key: 'idFornecedor',
                    label: this.$t(
                        'configuracaoParametros.formulario.campoFornecedor'
                    ),
                    value: this.nomeFornecedorPorId(
                        this.configuracao.idFornecedor
                    )
                },
                {
                    key: 'distanciaRaioKm',
                    label: this.$t(
                        'configuracaoParametros.formulario.campoDistanciaRaioKm'
                    ),
                    value: this.configuracao.distanciaRaioKm
                },
                {
                    key: 'percentualCapacidadeProdutiva',
                    label: this.$t(
                        'configuracaoParametros.formulario.campoPorExcCapProdutiva'
                    ),
                    value: this.configuracao.percentualCapacidadeProdutiva
                }
            ];
            return resumeList;
        },
        dadosParametrosExcecoes() {
            return (
                this.configuracao?.excecoes?.map(excecao => [
                    {
                        key: 'idEstado',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoEstado'
                        ),
                        value: this.nomeEstadoPorId(excecao?.idEstado)
                    },
                    {
                        key: 'tiposExececao',
                        label: this.$t(
                            'configuracaoParametros.formulario.placeholderTipoExececao'
                        ),
                        value: this.nomeTipoExcecaoPorValor(
                            excecao?.aplicarTodoEstado
                        )
                    },
                    {
                        key: 'distanciaRaioKm',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoDistanciaRaioKm'
                        ),
                        value: excecao?.distanciaRaioKm,
                        opcional: !excecao?.aplicarTodoEstado
                    },

                    {
                        key: 'percentualCapacidadeProdutiva',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoPorExcCapProdutiva'
                        ),
                        value: excecao?.percentualCapacidadeProdutiva
                    },
                    {
                        key: 'checkboxNaoUtilizarExececaoMunicipio',
                        label: this.$t(
                            'configuracaoParametros.formulario.checkboxNaoUtilizarExececaoMunicipio'
                        ),
                        value: excecao?.naoTemExcecaoMunicipio,
                        type: 'checkbox'
                    },
                    {
                        key: 'municipios',
                        type: 'list',
                        value:
                            this.criarExecoesMuniciops(
                                excecao?.excecoes,
                                excecao?.idEstado
                            ) || []
                    }
                ]) || []
            );
        }
    },
    methods: {
        buscarFornecedores() {
            ContratoOriginacaoService.buscarBpClientes()
                .then(({ data }) => {
                    this.fornecedores = data;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('mensagens.sistema.erroBuscarFornecedores')
                    );
                });
        },
        buscarEstados() {
            LocalidadeService.findEstados()
                .then(({ data }) => {
                    this.estados = data;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('mensagens.sistema.erroBuscarEstados')
                    );
                });
        },
        async buscarMunicipios(idEstado, indexExcecao) {
            if (idEstado) {
                await LocalidadeService.findMunicipios(idEstado)
                    .then(({ data }) => {
                        const municipios = this.municipios;
                        municipios.push({
                            id: idEstado,
                            data
                        });
                        this.municipios = municipios;
                    })
                    .catch(() => {
                        this.$notify.error(
                            this.$t('mensagens.sistema.erroBuscarMunicipios')
                        );
                    });
            }
        },
        async buscarDados() {
            const id = this.$route.params?.idConfiguracaoRastreabilidade;
            try {
                if (id) {
                    const parametros = await buscarParametros(id);

                    parametros.excecoes.forEach(async (excecao, index) => {
                        await this.buscarMunicipios(excecao.idEstado, index);
                    });
                    this.configuracao = parametros;
                } else {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroBuscarConfiguracao'
                        )
                    );
                }
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'configuracaoParametros.erro.erroBuscarConfiguracao'
                    )
                );
            }
        },
        nomeEstadoPorId(idEstado) {
            if (this.estados.length === 0) {
                return '';
            }
            return this.estados.find(estado => estado.id === idEstado)?.nome;
        },
        criarExecoesMuniciops(excecao, idEstado) {
            return (
                excecao.map(municipio => [
                    {
                        key: 'idMunicipio',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoMunicipio'
                        ),
                        value: this.nomeMunicipioPorId(
                            idEstado,
                            municipio?.idMunicipio
                        )
                    },
                    {
                        key: 'distanciaRaioKm',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoDistanciaRaioKm'
                        ),
                        value: municipio?.distanciaRaioKm
                    },
                    {
                        key: 'percentualCapacidadeProdutiva',
                        label: this.$t(
                            'configuracaoParametros.formulario.campoPorExcCapProdutiva'
                        ),
                        value: municipio?.percentualCapacidadeProdutiva
                    }
                ]) || []
            );
        },
        nomeMunicipioPorId(idEstado, idMunicipio) {
            if (this.municipios.length === 0) {
                return '';
            }
            const municipios = this.municipios.find(
                item => item.id === idEstado
            )?.data;
            const municipio = municipios?.find(
                municipio => municipio.id === idMunicipio
            );

            return municipio?.nome || '';
        },
        nomeFornecedorPorId(idFornecedor) {
            return this.fornecedores.find(
                fornecedor => fornecedor.id === idFornecedor
            )?.nome;
        },
        obterValorNaotemExcecaoMunicipio(excecao) {
            return (
                excecao.find(
                    item => item.key === 'checkboxNaoUtilizarExececaoMunicipio'
                )?.value || false
            );
        },
        nomeTipoExcecaoPorValor(value) {
            return value
                ? this.$t('configuracaoParametros.formulario.labelTodoEstado')
                : this.$t('configuracaoParametros.formulario.labelRaio');
        },
        voltarConfiguracao() {
            this.$router.push({ name: 'ParametrosFornecedor' });
        }
    }
};
</script>

<style lang="scss" scoped>
.configuracao-parametros-detalhes {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
    &__excecoes {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    &__excecao-municipio {
        margin-left: 20px;
        & + &::before {
            content: '';
            display: block;
            width: 50%;
            height: 1px;
            background-color: $default-border-color;
            margin: 20px 0;
        }
    }
    .resume {
        display: flex;
        flex-direction: column;
        gap: 18px;
        &__item {
            display: flex;
            flex-direction: column;
            gap: 6px;
            margin-top: 12px;
        }
        &__label {
            font-weight: bold;
            color: var(--primary);
        }
        &__value {
            font-size: 16px;
            color: #3b3b3b;
        }
    }
}

.el-checkbox {
    color: var(--primary);
    cursor: default !important;
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: var(--primary) !important;
    }
    input,
    .el-checkbox__input {
        cursor: default !important;
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
